/**
 * Turns nested plain objects in locale JSON into dot-notation keys for react-intl
 * (e.g. { promoModal: { demo: { title: "x" } } } -> { "promoModal.demo.title": "x" }).
 * Top-level string entries are copied as-is.
 *
 * @param {Record<string, unknown>} raw
 * @returns {Record<string, string>}
 */
export function expandMessagesForIntl(raw) {
  if (!raw || typeof raw !== "object") {
    return {};
  }
  /** @type {Record<string, string>} */
  const out = {};
  for (const [key, val] of Object.entries(raw)) {
    if (val !== null && typeof val === "object" && !Array.isArray(val)) {
      Object.assign(out, flattenLeaves(val, key));
    } else if (typeof val === "string") {
      out[key] = val;
    }
  }
  return out;
}

/**
 * @param {Record<string, unknown>} obj
 * @param {string} prefix
 * @returns {Record<string, string>}
 */
function flattenLeaves(obj, prefix) {
  /** @type {Record<string, string>} */
  const res = {};
  for (const [k, v] of Object.entries(obj)) {
    const path = "".concat(prefix, ".").concat(k);
    if (v !== null && typeof v === "object" && !Array.isArray(v)) {
      Object.assign(res, flattenLeaves(v, path));
    } else if (typeof v === "string") {
      res[path] = v;
    }
  }
  return res;
}